export const REVIEWS_TAGS_SEARCH_TYPE = {
  INCLUDE_ANY_TAG: 1,
  INCLUDE_ALL_TAGS: 2,
  NO_TAGS: 0
};

export const REVIEWS_ACTION = {
  ONLY_UPDATED: "ONLY_UPDATED",
  ONLY_CREATED: "ONLY_CREATED"
};

export const REVIEWS_ACTION_TRANSLATION_KEY = {
  ALL: "allRatingsIncluded",
  ONLY_UPDATED: "editedRatingIncluded",
  ONLY_CREATED: "newRatingsIncluded"
};

export const REVIEW_PHOTO_TYPE = {
  REVIEW: "review",
  FACILITY: "facility"
};

export const REVIEW_PHOTO_THUMBNAIL_SIZE = {
  LARGE: "large",
  SMALL: "small"
};

export const PHOTO_VIEW_VARIANT = {
  THUMBNAIL: "thumbnail",
  FULL_SIZE: "full_size"
};

export const REVIEWS_GROUP_BY = {
  FACILITY: "facility",
  FACILITY_GROUP: "facility_group",
  CITY: "city"
};
